export type Role = {
  id: number;
  name: string;
  description?: string | null;
  isAdmin: boolean;
  isReadOnly: boolean;
};

export const REPORTING_ONLY_ROLE_NAME = 'ReportingOnly';
export const RETURN_MAIL_TEAM_ROLE_NAME = 'ReturnMailTeam';
export const ADMIN_ROLE_NAME = 'Admin';
export const DEVELOPER_ROLE_NAME = 'Developer';

export const getRoleIdByName = (roleName: string): number | null => {
  switch (roleName) {
    case ADMIN_ROLE_NAME:
      return 2;
    case DEVELOPER_ROLE_NAME:
      return 3;
    case REPORTING_ONLY_ROLE_NAME:
      return 1;
    case RETURN_MAIL_TEAM_ROLE_NAME:
      return 4;
  }

  return null;
};
